export enum VehicleAlbums {
  PHOTOS_CAR_ORIGINAL = 'PHOTOS_CAR_ORIGINAL',
  PHOTOS_CAR_SALES = 'PHOTOS_CAR_SALES',
  PHOTOS_CAR_PURCHASE = 'PHOTOS_CAR_PURCHASE',
  PHOTOS_SERVICE_CASE = 'PHOTOS_SERVICE_CASE',
  PHOTOS_CUSTOM = 'PHOTOS_CUSTOM',
}
